// extracted by mini-css-extract-plugin
export default {"card":"ZoneCard_card__uNZzN"};